import dynamic from "next/dynamic";

export const DynamicFooter003 = dynamic(() => import("./Footer003"), {
  suspense: true,
});
